<template>
    <div class="container">
        <b-modal :model-value="modCrearTipoMoneda" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                {{ labels.title }} 
            </div>
            <div>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codigo}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" :items="codigo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.descripcion}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" :items="descripcion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.acronimo}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" :items="acronimo" class="form-control">
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <b-button class="md-primary" @click="guardarTipoMoneda">{{ labels.save }}</b-button> 
                    <b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import TipoMoneda from '../../../services/TipoMoneda'; 

export default {
    name : 'Crear',
    props: ['modCrearTipoMoneda'],
    data: () => ({
        codigo : null,
        descripcion : '',
        acronimo : '',
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Crear tipo moneda',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    acronimo : 'Acrónimo',
                    save : 'Guardar',
                    close : 'Cerrar',
                }
            }else{
                return {
                    title : 'Create currency type',
                    codigo : 'Code',
                    descripcion : 'Description',
                    acronimo : 'Acronym',
                    save : 'Save',
                    close : 'Close',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        guardarTipoMoneda(){
            const dataForm = [
                this.codigo, 
                this.descripcion, 
                this.acronimo 
            ]

            if(dataForm.includes('')){ 
                this.$toast.error('Campo(s) pendiente(s) por diligenciar') 
            }else{
                let info = {
                    'moneda' : this.codigo, 
                    'descripcion' : this.descripcion, 
                    'acronimo' : this.acronimo, 
                    'idUser' : this.$store.state.userId 
                }
                // console.log(info); 
                TipoMoneda.createTipoMoneda(info) 
                .then((res) => { 
                    if(res.status == 201){ 
                        this.$toast.success(res.data?.message || 'Tipo moneda guardado correctamente') 
                        setTimeout(() => location.reload(), 800) 
                    
                    }else if(res.status == 204){ 
                        this.$toast.error('Tipo moneda ya existe.') 
                        return
                    }else{
                        this.$toast.error(res.data?.message || 'No fue posible guardar el tipo moneda') 
                    }
                })
                .catch((err) => { 
                    console.log(err) 
                    this.$toast.error('Ocurrió un error al guardar el tipo moneda') 
                }) 
            }
        }
    }
}
</script>

<style>

</style>
